<template>
  <div
    v-if="progressBarState"
    class="progress-loader"
  >
    <div class="loader--background">
      <div class="loader--bar" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'progress-loader',
  data: function() {
    return {
    }
  },
  computed: {
    progressBarState: function() {
      return this.$store.state.progressLoaderState
    }
  },
  created: function() {
    this.$eventHub.$on('showProgressLoader', () => { this.$store.dispatch('showProgressLoader') })
    this.$eventHub.$on('hideProgressLoader', () => { this.$store.dispatch('hideProgressLoader') })
  }
}
</script>

<style lang='scss'>

  .progress-loader {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    overflow: hidden;
    display: inline-block;
    z-index: 1000;
    background: transparent;

    .loader--background {
      height: 4px;
      display:flex;
      width: 100%;
      left: 0;
      top: 0px;
      position: relative;
      z-index: -1;
    }

    .loader--bar {
      top: 0px;
      height: 10px;
      position: relative;
      width: 0;
      display: inline-block;
      background-image: linear-gradient(to right, transparent, var(--main-progress-loader-color));
      animation: growth 1.5s ease-in-out infinite;
    }
  }
</style>
